import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import SubmitPage from './pages/SubmitPage';
import RunPage from './pages/RunPage';
import EnzymeRunPage from './pages/EnzymeRunPage';
import CompatibilityRunPage from './pages/CompatibilityRunPage';
import {ThemeProvider} from "@mui/material/styles";
import theme from "./theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router basename="/">
        <Routes>
          <Route path="/" element={<SubmitPage/>}/>
          <Route path="/run/:id" element={<RunPage/>}/>
          <Route path="/enzyme-run/:id" element={<EnzymeRunPage/>}/>
          <Route path="/compatibility/:id" element={<CompatibilityRunPage/>}/>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
